var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Model, TransformValidateModel, validator, createFunction, } from "@musicaudienceexchange/toccata";
import { RequestTypes } from "../firestore";
export const Platforms = ["nextsong", "setlive"];
export const PaymentTypes = RequestTypes;
export class Payment extends Model {
}
__decorate([
    validator.IsNumber(),
    validator.Min(0),
    validator.IsDivisibleBy(100)
], Payment.prototype, "amount", void 0);
__decorate([
    validator.IsString(),
    validator.IsIn(PaymentTypes)
], Payment.prototype, "type", void 0);
__decorate([
    validator.IsString()
], Payment.prototype, "eventId", void 0);
__decorate([
    validator.IsString(),
    validator.IsOptional(),
    validator.ValidateIf((o) => o.type === "vote" || o.type === "sponsor" || o.type === "encore")
], Payment.prototype, "songId", void 0);
__decorate([
    validator.IsEmail()
], Payment.prototype, "email", void 0);
__decorate([
    validator.IsString(),
    validator.MinLength(3)
], Payment.prototype, "name", void 0);
__decorate([
    validator.IsString(),
    validator.IsOptional()
], Payment.prototype, "phone", void 0);
__decorate([
    validator.IsString(),
    validator.IsOptional()
], Payment.prototype, "location", void 0);
__decorate([
    validator.IsString(),
    validator.IsOptional()
], Payment.prototype, "zipcode", void 0);
__decorate([
    validator.ValidateIf((o) => o.type === "sponsor"),
    validator.IsOptional()
    //@TransformValidateModel(Sponsorship)
    // HACK: For some reason TransformValidateModel is not working correctly here.
    // TODO: Get TransformValidateModel working properly here
    ,
    validator.IsObject()
], Payment.prototype, "sponsorship", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsObject()
], Payment.prototype, "extraFields", void 0);
__decorate([
    validator.IsString(),
    validator.IsOptional()
], Payment.prototype, "displayName", void 0);
__decorate([
    validator.IsBoolean(),
    validator.IsOptional()
], Payment.prototype, "read", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsObject()
    // @TransformValidateModel(Coordinates)
], Payment.prototype, "coordinates", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsNumber()
], Payment.prototype, "distance", void 0);
export class PaymentInitRequest extends Model {
}
PaymentInitRequest.defaults = {
    action: "init",
    savePaymentMethod: true,
};
__decorate([
    validator.Equals("init")
], PaymentInitRequest.prototype, "action", void 0);
__decorate([
    validator.IsBoolean()
], PaymentInitRequest.prototype, "savePaymentMethod", void 0);
__decorate([
    TransformValidateModel(Payment)
], PaymentInitRequest.prototype, "payment", void 0);
export class PaymentInitResponse extends Model {
}
__decorate([
    validator.IsString()
], PaymentInitResponse.prototype, "secret", void 0);
__decorate([
    validator.IsString()
], PaymentInitResponse.prototype, "id", void 0);
export class PaymentFinalizeRequest extends Model {
}
PaymentFinalizeRequest.defaults = {
    action: "finalize",
};
__decorate([
    validator.Equals("finalize")
], PaymentFinalizeRequest.prototype, "action", void 0);
__decorate([
    validator.IsString()
], PaymentFinalizeRequest.prototype, "id", void 0);
export class PaymentFinalizeResponse extends Model {
}
export class Setup extends Model {
}
__decorate([
    validator.IsString(),
    validator.IsOptional()
], Setup.prototype, "name", void 0);
__decorate([
    validator.IsString(),
    validator.IsOptional()
], Setup.prototype, "email", void 0);
__decorate([
    validator.IsString(),
    validator.IsOptional()
], Setup.prototype, "phone", void 0);
export class SetupInitRequest extends Model {
}
SetupInitRequest.defaults = {
    action: "setup_init",
};
__decorate([
    validator.Equals("setup_init")
], SetupInitRequest.prototype, "action", void 0);
__decorate([
    TransformValidateModel(Setup),
    validator.IsOptional()
], SetupInitRequest.prototype, "setup", void 0);
export class SetupInitResponse extends Model {
}
__decorate([
    validator.IsString()
], SetupInitResponse.prototype, "secret", void 0);
__decorate([
    validator.IsString()
], SetupInitResponse.prototype, "id", void 0);
export class SetupFinalizeRequest extends Model {
}
SetupFinalizeRequest.defaults = {
    action: "setup_finalize",
};
__decorate([
    validator.Equals("setup_finalize")
], SetupFinalizeRequest.prototype, "action", void 0);
__decorate([
    validator.IsString()
], SetupFinalizeRequest.prototype, "id", void 0);
export class SetupFinalizeResponse extends Model {
}
__decorate([
    validator.IsOptional(),
    validator.IsString()
], SetupFinalizeResponse.prototype, "paymentMethod", void 0);
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function init(functions, createCallable, platform = "nextsong") {
    return {
        initPayment: createFunction(functions, createCallable, `${platform}-payments`, PaymentInitRequest, PaymentInitResponse),
        finalizePayment: createFunction(functions, createCallable, `${platform}-payments`, PaymentFinalizeRequest, PaymentFinalizeResponse),
        initSetup: createFunction(functions, createCallable, `${platform}-payments`, SetupInitRequest, SetupInitResponse),
        finalizeSetup: createFunction(functions, createCallable, `${platform}-payments`, SetupFinalizeRequest, SetupFinalizeResponse),
    };
}
//# sourceMappingURL=index.js.map